import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {SoftwareMainIcon, SoftwareProIcon, BackendIcon, FrontEndIcon} from "../../../../app-constants";

const StackItem = [
    {
        icon: SoftwareProIcon,
        title: 'Software Testing',
        description: 'Selenium, Appium, Apache JMeter, Soap UI, TestRail',
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Maintenance',
        description: 'Git, Jira, Selenium, JUnit, New Relic, Splunk',
    },
    {
        icon: FrontEndIcon,
        title: 'Frontend Stack',
        description: 'JavaScript, Node.js, React.js, Angular, Vue.js',
    },
    {
        icon: BackendIcon,
        title: 'Backend Stack',
        description: 'Java, Django, Ruby on Rails (RoR), Python, React Native, SQL',
    }

];


function Technology(props) {
    return (
        <div className="technoloy_sec p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
                        <div className="example" data-text="Tech">
                            <h2>TekRevol’s Rich Tech Stack for Custom Software Development in London</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto offset-xl-1">
                        <p>We believe in constant improvisation when it comes to the technology used for software development. Having mastery of multiple stacks, our bespoke software developers UK regulate the authentic development of robust software products. </p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
                        <div className="technology_main">
                            {StackItem.map((item, index) => (
                                <div className="technology_item">
                                    <div className="svg_icon">
                                        {item.icon}
                                    </div>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Technology;